/**
 * Local class-name merge helper for the v3 menu CSS-class components.
 *
 * `cn` is not exported from @sproutsocial/seeds-react-utilities, so — mirroring
 * ButtonTailwind/MessageTailwind — the menu package keeps a local copy. Accepts
 * strings and { className: boolean } records; falsy entries are dropped.
 */
/**
 * Narrow a Base UI component's props so `className` is a plain string. Base UI
 * types `className` as `string | ((state) => string)`; the v3 CSS-class
 * wrappers only ever forward a string (no consumer uses the function form), and
 * a string is what `cn` accepts.
 */
export type WithStringClassName<P> = Omit<P, "className"> & {
  className?: string;
};

export function cn(
  ...inputs: (string | undefined | null | false | Record<string, boolean>)[]
): string {
  const classes: string[] = [];

  for (const input of inputs) {
    if (!input) continue;

    if (typeof input === "string") {
      classes.push(input);
    } else if (typeof input === "object") {
      for (const [key, value] of Object.entries(input)) {
        if (value) {
          classes.push(key);
        }
      }
    }
  }

  return classes.join(" ");
}
